import { useState } from "react";

export const CHECK_STATUS_CONSTANTS = {
  CLAIM_STATUS: "ClaimStatus",
  POLICY_STATUS: "PolicyStatus",
};

export const SEARCH_STATUS_TABS = [
  { id: CHECK_STATUS_CONSTANTS.CLAIM_STATUS, label: "Claim Status" },
  { id: CHECK_STATUS_CONSTANTS.POLICY_STATUS, label: "Policy Status" },
];

export const useExportConstData = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [activeTab, setActiveTab] = useState(
    CHECK_STATUS_CONSTANTS.CLAIM_STATUS
  );

  return {
    activeTab,
    setActiveTab,
    isLoading,
    setIsLoading,
  };
};
